export default __webpack_public_path__ + "static/media/pencil-black.8d40f2e2.svg";